import { AbstractControl, FormArray, FormControl, FormGroup, ValidatorFn } from "@angular/forms";



export interface BooleanFn {
    (frm:FormGroup | FormArray): boolean;
  }
export function noSpacesValidator(control: FormControl) {

    if (control.value ===null ||control.value.trim().length === 0) {
      return { noSpaces: true };
    }

    return null;

  }

export function conditionalValidator(predicate: BooleanFn,validator: ValidatorFn,errorNamespace?: string): ValidatorFn {
    return (formControl) => {
      if (!formControl.parent) {
        return null;
      }
      let error = null;
      if (predicate(formControl.parent)) {
        error = validator(formControl);
      }
      if (errorNamespace && error) {
        const customError:any = [];
        customError[errorNamespace] = error;
        error = customError;
      }
      return error;
    };
  }

  export function swissPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } => {
      const phoneNumber = control.value.replace(/\D/g, '');
      const isValid = phoneNumber.length === 10 && /^[0-9]*$/.test(phoneNumber);

      return isValid ? {} : { 'swissPhone': true };
    };
  }

  export function validatePlaceNbr(reserved: number): (control: AbstractControl) => { [key: string]: boolean } | null {

    return (control: AbstractControl) => {
      console.log(reserved,control.value)
      if (control.value < reserved) {
        return { invalidPlaceNbr: true };
      }
      return null;
    };
  }

  export function startDateBeforeEndDate(control: AbstractControl): { [key: string]: boolean } | null {
    const start = control.get('start_at');
    const end = control.get('end_at');

    if (start?.value > end?.value) {
      return { startDateBeforeEndDate: true };
    }

    return null;
  }
